import { Component, OnInit, ViewChild, EventEmitter, Output, TemplateRef } from '@angular/core';
import { UtilityService } from '../services/utility.service';
import { UserService } from '../services/user.service';
import { MasterMOMService } from '../services/master-mom.service';
import { momDashboard, momDashboard_MyMeetings, AttendeesAtd, momDashboard_PartofMeetings, MeetingAppoinments } from '../models/MOMForm';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import Notiflix from "notiflix";
import { pairText } from '../models/users';
import { AdminService } from '../services/admin.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  public objmomDashboard: momDashboard = new momDashboard();
  public lstMOMDashboard_MyMeetings: momDashboard_MyMeetings[] = [];
  public lstMOMDashboard_PartofMeetings: momDashboard_PartofMeetings[] = [];
  public lstMOMDashboard_TodayMeetings: momDashboard_MyMeetings[] = [];
  public lstMOMDashboard_MyActionItems: momDashboard_MyMeetings[] = [];
  public myTaskList: any = [];
  loginUserId: number = 0;
  user: any;
  modalRef: BsModalRef;
  modalActionPoint: BsModalRef;
    mid: any;
    noDataImage: string;
  isLoader: boolean = false;
  public ngbModalOptions: any = {
    backdrop: 'static',
    keyboard: false
  };
    agendaInfo: any=[];
    viewType: string="view";
    meetingEditUno: any;
  modalText: string ="Create new MOM";
    UserList: any=[];
    role: number;
    strK1: string;
    strI1: string;
  constructor(private modalService: BsModalService,
    public utilityService: UtilityService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private momService: MasterMOMService,
    private userService: UserService,
    public restApi: AdminService) {
  }

  ngOnInit(): void {
    this.noDataImage = this.utilityService.getnodataImage();
    this.user = this.userService.getUserInfo();
 
    if(this.user==undefined){
      this.userService.logout();
    }
    else{
    this.loginUserId = this.user.id;
    this.role = parseInt(this.user.role);
    }   

    this._activatedRoute.queryParams.subscribe((params: Params) => {
      let QisScheduler = params['isScheduler'];
      let isScheduler = QisScheduler != null && QisScheduler != undefined && QisScheduler != '' ? QisScheduler : 0;
      if (isScheduler > 0) {
        this.SchedularCall(isScheduler);
      }

    });
    this.loadpairText();
    setTimeout(() => {
    var elementSideBarReport = document.getElementById('sideBarReport') as HTMLInputElement;
    if (elementSideBarReport != null) {
      elementSideBarReport.style.display = (this.role == 1) ? "block" : "none";
    }
    var elementsideBarSettings = document.getElementById('sideBarSettings') as HTMLInputElement;
    if (elementsideBarSettings != null) {
      elementsideBarSettings.style.display = (this.role == 1) ? "block" : "none";
    }
    var elementheaderSettings = document.getElementById('headerSettings') as HTMLInputElement;
    if (elementheaderSettings != null) {
      elementsideBarSettings.style.display = (this.role == 1) ? "block" : "none";
      }
    }, 500);
    this.getDashboardInfo()
  }
  ngAfterViewInit() {
    setTimeout(() => {
      var elementSideBarReport = document.getElementById('sideBarReport') as HTMLInputElement;
      if (elementSideBarReport != null) {
        elementSideBarReport.style.display = (this.role == 1) ? "block" : "none";
      }
      var elementsideBarSettings = document.getElementById('sideBarSettings') as HTMLInputElement;
      if (elementsideBarSettings != null) {
        elementsideBarSettings.style.display = (this.role == 1) ? "block" : "none";
      }
      var elementheaderSettings = document.getElementById('headerSettings') as HTMLInputElement;
      if (elementheaderSettings != null) {
        elementsideBarSettings.style.display = (this.role == 1) ? "block" : "none";
      }
    }, 500);
  }
  openActionPointModal(template: TemplateRef<any>, id: any) {
    ;
    this.getActionPointMeetingDetails(id);
    this.modalActionPoint = this.modalService.show(template, Object.assign({}, { class: 'modal-md' }, this.ngbModalOptions));

  }

  openEditModal(template1: TemplateRef<any>, id, type: any) {
    let that = this;
    if (this.UserList == null || this.UserList == undefined || this.UserList.length == 0) {
      this.getUserList();

      setTimeout(function () {
        that.mid = id;
        that.viewType = type;
        that.modalRef = that.modalService.show(template1, Object.assign({}, { class: 'gray modal-xl modal-full modal-dialog-scrollable modal-body-scrollable' }, that.ngbModalOptions)
        );
      }, 600);
    }
    else {
      that.mid = id;
      that.viewType = type;
      that.modalRef = that.modalService.show(template1, Object.assign({}, { class: 'gray modal-xl modal-full modal-dialog-scrollable modal-body-scrollable' }, that.ngbModalOptions)
      );
    }

  }

  openAddModal(template2: TemplateRef<any>, id: any) {
    let that = this;
    if (this.UserList == null || this.UserList == undefined || this.UserList.length == 0) {
      this.getUserList();

      setTimeout(function () {
        that.meetingEditUno = id;
        if (id != '' && id > 0 && id != undefined) {
          that.modalText = "Edit MOM";
        }
        else {
          that.modalText = "Create new MOM";
        }
        that.modalRef = that.modalService.show(template2, Object.assign({}, { class: 'gray modal-xl modal-full modal-dialog-scrollable modal-body-scrollable' }, that.ngbModalOptions)
        );
      }, 600);
    }
    else {
      that.meetingEditUno = id;
      if (id != '' && id > 0 && id != undefined) {
        that.modalText = "Edit MOM";
      }
      else {
        that.modalText = "Create new MOM";
      }
      that.modalRef = that.modalService.show(template2, Object.assign({}, { class: 'gray modal-xl modal-full modal-dialog-scrollable modal-body-scrollable' }, that.ngbModalOptions)
      );
    }
  }

  SchedularCall(isScheduler:any) {
    ;
    let inpValue = new momDashboard();
    inpValue.startIndex = isScheduler;
    this.restApi.SchedularCall(inpValue)
      .subscribe(data => {
        ;
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  loadpairText() {
    let inpValue = new pairText();
    inpValue.k1 = '';
    this.restApi.callpairText(inpValue)
      .subscribe(data => {
        let rtnData: pairText;
        rtnData = data;
        this.strK1 = rtnData.k1;
        this.strI1 = rtnData.i1;
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  getActionPointMeetingDetails(id:any) {
    this.isLoader = true;
    // Notiflix.Block.Dots('.pageloadcontainer');
    let inpValue = new momDashboard_MyMeetings();
    inpValue.genInfoAtdUno = id;
    this.momService.getActionPointMeetingDetails(inpValue)
      .subscribe((data: any) => {
        this.agendaInfo = data[0];
        console.log("agendaInfo", this.agendaInfo);
        //Notiflix.Block.Remove('.pageloadcontainer', 800);
      },
        (error) => {
          this.isLoader = false;

          // Notiflix.Block.Remove('.pageloadcontainer', 800);
        }
      ).add(() => {
        this.isLoader = false;

        //Notiflix.Block.Remove('.pageloadcontainer', 800);
      });

  }

  getDashboardInfo() {
    this.isLoader = true;
    this.lstMOMDashboard_MyMeetings = [];
    this.objmomDashboard = new momDashboard();
    this.lstMOMDashboard_PartofMeetings = [];
    this.lstMOMDashboard_TodayMeetings = [];
    this.lstMOMDashboard_MyActionItems = [];
    this.myTaskList = [];
   // Notiflix.Block.Dots('.pageloadcontainer');
    let inpValue = new momDashboard();
    inpValue.userUno = this.loginUserId;
    this.momService.getMOMDashboard(inpValue)
      .subscribe((data: any) => {
        this.objmomDashboard = data;
        this.lstMOMDashboard_MyMeetings = data.lstMOMDashboard_MyMeetings;
        this.lstMOMDashboard_PartofMeetings = data.lstMOMDashboard_PartofMeetings;
      
        this.lstMOMDashboard_TodayMeetings = data.lstMOMDashboard_TodayMeetings;
        this.lstMOMDashboard_MyActionItems = data.lstMOMDashboard_MyActionItems;
        this.myTaskList = data.lstMOMDashboard_MyTasks;
        this.isLoader = false;
        console.log("dashboard", this.lstMOMDashboard_MyActionItems);
        //Notiflix.Block.Remove('.pageloadcontainer', 800);
      },
        (error) => {
          this.isLoader = false;

         // Notiflix.Block.Remove('.pageloadcontainer', 800);
        }
    ).add(() => {
      this.isLoader = false;

      //Notiflix.Block.Remove('.pageloadcontainer', 800);
      });

  }


  redirectMeetingMinutes(type: any) {

    this._router.navigate(['/meetingofminutes'], { queryParams: { QType: btoa(type) } });
  }
  getPopUpOutput(edit: boolean) {

    if (edit) {
      this.getDashboardInfo();
    }
  }
  getUserList() {
    let inpValue = new AttendeesAtd();
    inpValue.userUno = this.loginUserId;
    this.momService.getUserList(inpValue)
      .subscribe(data => {
        this.UserList = data;

      },
        () => {
        }
      ).add(() => {
      });
  }
}
